import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import AllotmentFilters from "./_filters";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import { LB_CODE, LB_NAME, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {activityService} from "../../../jwt/_services/core/activityService";

// utils
import {getStateByPath} from "../../../redux/selectors";


import '../../../assets/css/icons.css';
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import NotifyAllotment from "./_notify";




const AllotmentList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    const {fbDataBase} = app

    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter(path, {
            fbDataBase,
            item: { searchRestaurants: true }
        })
    }, [app]);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, activityService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const confirmNotification = (activity, allotment) => ModalFormContainer(NotifyAllotment, {activity, allotment, path})


    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '80px'},
            hidden: true
        }, {
            dataField: 'name',
            text: `${LB_NAME}`,
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `Allotment`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '195px'},
            formatter: (cell, row) => <>
                <GenericTableButton
                    iconClazz={'icon-green'}
                    toolTip={'Ocupación Baja'}
                    icon={'fa-circle'}
                    permission={'edit'}
                    onClick={() => confirmNotification(row, 'BAJO')}
                />
                <GenericTableButton
                    iconClazz={'icon-yellow'}
                    toolTip={'Ocupación Media'}
                    icon={'fa-circle'}
                    permission={'edit'}
                    onClick={() => confirmNotification(row, 'MEDIO')}
                />
                <GenericTableButton
                    iconClazz={'icon-red'}
                    toolTip={'Ocupación Alta'}
                    icon={'fa-circle'}
                    permission={'edit'}
                    onClick={() => confirmNotification(row, 'ALTO')}
                />

            </>
        }];
    
    

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
        </CardTitle>

        <AllotmentFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(AllotmentList);